import React from "react";
import PropTypes from "prop-types";
import { FormGroup, FormFeedback } from "reactstrap";

import errorsForField from "shared/formik/errorsForField";
import TagListInput from "shared/react_components/TagListInput";
import LoaderOverlay from "shared/react_components/LoaderOverlay";

import { useLazyQuery } from "@apollo/react-hooks";
import { GetColumnValues } from "dashboard/views/components/Reports.graphql";

const booleanFilterOptions = ["Yes", "No", "Not Applied"].map(filter => ({ value: filter, label: filter }));

const FilterValues = ({ fieldName, item, currentDateRange, filterType, form, fieldUpdater, index }) => {
  let filterValues, onFocus;
  const [loadFilterValues, { called, loading, data }] = useLazyQuery(GetColumnValues, {
    variables: { dateRange: currentDateRange, columnName: item.filterKey, schema: "BusinessObject" }
  });

  if (!item.filterKey) {
    filterValues = [];
    onFocus = () => true;
  } else if (filterType === "Boolean") {
    filterValues = booleanFilterOptions;
    onFocus = () => true;
  } else {
    filterValues = data ? data.columnValues.map(filter => ({ value: filter, label: filter })) : [];
    onFocus = loadFilterValues;
  }

  return (
    <LoaderOverlay loading={called && loading}>
      <FormGroup name={`${fieldName}[${index}].filterValues`}>
        <TagListInput
          isDisabled={!item.filterKey}
          allowCustomOptions={filterType !== "Boolean"}
          name={`${fieldName}[${index}].filterValues`}
          value={item.filterValues}
          valueDelimiters={["Enter", "Tab", ","]}
          options={filterValues}
          onChange={fieldUpdater.fromEventTarget("filterValues")}
          onBlur={() =>
            form.setFieldTouched(`${fieldName}[${index}].filterValues`, true)
          }
          onFocus={onFocus}
          isUnique={(val, vals) =>
            !vals.find(existing => existing.toLowerCase() === val.toLowerCase())
          }
        />
        <FormFeedback className="d-block">
          {errorsForField(form, `${fieldName}[${index}].filterValues`)}
        </FormFeedback>
      </FormGroup>
    </LoaderOverlay>
  );
};

FilterValues.propTypes = {
  fieldName: PropTypes.string.isRequired,
  item: PropTypes.shape({
    filterKey: PropTypes.string,
    filterValues: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  currentDateRange: PropTypes.string.isRequired,
  filterType: PropTypes.string,
  form: PropTypes.object,
  fieldUpdater: PropTypes.func,
  index: PropTypes.number
};

export default FilterValues;
